import { responseFormat, translateDataToTree } from '@/utils'
import { UPDATE_TOKEN, UPDATE_USER_INFO, UPDATE_PERMISSIONS_LIST, UPDATE_PERMISSIONS, UPDATE_TASKTYPE, UPDATE_BUSINESSTYPE } from './mutation-types'
export default {
  [UPDATE_TOKEN]: (state, payload) => {
    state.token = payload
  },
  [UPDATE_USER_INFO]: (state, payload) => {
    state.userInfo = payload
  },
  [UPDATE_PERMISSIONS_LIST]: (state, payload) => {
    state.permissions = payload
  },
  [UPDATE_PERMISSIONS]: (state, payload = []) => {
    // 找出后台权限项
    const formatData = responseFormat.string2number(payload, ['parent_id', 'order'], true)
    const current = formatData.filter(item => item.type === '2')
    const permissions = []
    const operateAuth = []
    const healths = []
    const xunjian = []
    const bzmj = []
    const gsgj = []
    const nps = []
    for (let item of current) {
      if (item.uri) {
        permissions.push(item.uri)
        switch (item.project) {
          case 'jiankangdu':
            healths.push(item)
            break
          case 'xunjian':
            xunjian.push(item)
            break
          case 'bzmj':
            bzmj.push(item)
            break
          case 'gsgj':
            gsgj.push(item)
            break
          case 'nps':
            nps.push(item)
            break
          default:
            healths.push(item)
            xunjian.push(item)
            bzmj.push(item)
            gsgj.push(item)
            nps.push(item)
            break
        }
      } else if (item.prop) {
        operateAuth.push(item.prop)
      }
    }
    // 用户权限
    state.userPermissions = current
    // 路由权限
    state.routeAuth = permissions
    // 操作权限
    state.operateAuth = operateAuth
    state.routes = translateDataToTree(healths)
    state.xunjianRoutes = translateDataToTree(xunjian)
    state.bzmjRoutes = translateDataToTree(bzmj)
    state.gsgjRoutes = translateDataToTree(gsgj)
    state.npsRoutes = translateDataToTree(nps)
  },
  [UPDATE_TASKTYPE]: (state, payload) => {
    state.task_type = payload
  },
  [UPDATE_BUSINESSTYPE]: (state, payload) => {
    state.business_type = payload
  }
}
